export type TreeRoot = {
  nodeKey?: string
  nodeValue?: number
  maxLeafValue?: number
}

export const IgnoredTreeKeys = ['id', '__typename', 'nodeKey', 'nodeValue', 'maxLeafValue']
